'use client';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';

/**
 * **실시간으로 더 찾는 중** — 원장에 적거나 낡았으면 그때 더 뒤지는데, 그동안 결과 위에 두는 띠(글자 한 줄 + 가는 진행 막대).
 *
 * 🔑 컨텐츠 허브와 브랜드 허브가 **같은 띠**를 쓴다 — 보강은 두 화면에서 같은 일이라 같아 보여야 한다.
 * ⚠️ 몇 건이 올지 모른다 — ⛔ 여기 수를 적지 마라.
 * ⚠️ 다 돌고 **한 건도 못 찾았을 때**는 부르는 쪽이 이 띠를 걷는다(빈 띠를 남기지 않는다).
 * ⚠️ 바깥 여백이 없다 — 아래 격자와의 사이는 부르는 쪽의 묶음(`Stack spacing`)이 준다.
 */
export function LiveNotice({ label }: { label: string }) {
  return (
    <Box role="status">
      <Typography sx={{ mb: 1, typography: 'uiMeta', color: 'text.secondary' }}>{label}</Typography>
      <LinearProgress sx={{ height: 3, borderRadius: 2 }} />
    </Box>
  );
}
